import api from './api';

export async function login(password, userId) {
  const response = await api.post('/auth/login', { password, user_id: userId });
  return response.data;
}

export async function logout() {
  const response = await api.post('/auth/logout');
  return response.data;
}

export async function getStatus() {
  const response = await api.get('/auth/status');
  return response.data;
}

export async function getUsers() {
  const response = await api.get('/auth/users');
  return response.data;
}

export async function setup(password, users) {
  const response = await api.post('/auth/setup', { password, users });
  return response.data;
}
